import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { ticketingService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { useTicketColumns } from 'components/common/enhanced/common-headers';
import { Button, ButtonGroup } from '@mui/material';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { isDirector } from 'components/helpers/IsDirector';
import { isSupplier } from 'components/helpers/IsSupplier';
import { isTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import { isTechnician } from 'components/helpers/IsTechnician';
import { isTechnicianCoordinator } from 'components/helpers/IsTechnicianCoordinator';

export const Tickets = () => {
  const translationPrefix = 'pages.tickets';

  const isDisableEdit = isDirector() || isSupplier();
  const isAdmin = isTenantAdministrator();
  const canViewToApprove = isAdmin || isTechnician() || isTechnicianCoordinator();

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [numTicketPending, setNumTicketPending] = useState(0);

  useEffect(() => {
    ticketingService.getTechnicianCreated(0, 0).then((res) => {
      setNumTicketPending(res.count);
    });
  }, []);

  const handleDelete = (line) => {
    ticketingService.delete(line.id).then(() => {
      datagridRefresh.current();
    });
  };

  const columns = useTicketColumns();
  columns.splice(6, 1);
  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.already-approved`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              {canViewToApprove && (
                <Link to="technician-created">
                  <Button
                    variant="outlined"
                    size="small"
                    color={numTicketPending > 0 ? 'error' : 'success'}>
                    {t(`${translationPrefix}.technician-created`)} ({numTicketPending})
                  </Button>
                </Link>
              )}
              {/* {canViewToApprove && (
                <Link to="to-approve">
                  <Button
                    variant="outlined"
                    size="small"
                    color={numTicketPending > 0 ? 'error' : 'success'}>
                    {t(`${translationPrefix}.to-approve`)} ({numTicketPending})
                  </Button>
                </Link>
              )} */}
              <div className="px-2">
                {!isDisableEdit && (
                  <Link to="new">
                    <Button variant="outlined" size="small">
                      <AddIcon />
                      {t(`${translationPrefix}.add`)}
                    </Button>
                  </Link>
                )}
              </div>
              <Link to="archive">
                <Button variant="outlined" size="small" color="warning">
                  {t(`global.archive`)}
                </Button>
              </Link>
            </ButtonGroup>
          </div>
        }>
        <EnhancedDataGrid
          columns={columns}
          service={ticketingService}
          getMethod={ticketingService.getAlreadyApproved}
          refresh={datagridRefresh}
          disableDelete
          initialOptions={{
            pinnedColumns: { left: [], right: [] }
          }}
        />
      </TenantPage>
    </>
  );
};

export default Tickets;
